import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Index from "./pages/Index";
import Book from "./pages/Book";
import Deathmatch from "./pages/Deathmatch";
import DeathMatchContest from "./pages/DeathMatchContest";
import PoetIndex from "./pages/PoetIndex";
import About from "./pages/About";
import NotFound from "./pages/NotFound";
import Generate from "./pages/Generate";
import TestHighlights from "./test-highlights";
import TooltipDemo from "./pages/admin/TooltipDemo";
import AdminHighlightRegeneration from "./pages/admin/AdminHighlightRegeneration";
import AdminPrompts from "./pages/admin/AdminPrompts";
import AdminProtectedPoems from "./pages/admin/AdminProtectedPoems";
import ManageData from './pages/admin/ManageData';
import { LoginForm } from './components/auth/LoginForm';
import ProtectedRoute from './components/auth/ProtectedRoute';

const App = () => (
  <BrowserRouter>
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Index />} />
        <Route path="/book" element={<Book />} />
        <Route path="/poets" element={<PoetIndex />} />
        <Route path="/deathmatch" element={<Deathmatch />} />
        <Route path="/deathmatch/contest" element={<DeathMatchContest />} />
        <Route path="/about" element={<About />} />
        <Route path="/generate" element={<Generate />} />
        <Route path="/test-highlights" element={<TestHighlights />} />
        <Route path="/admin" element={<LoginForm />} />
        <Route path="/admin/highlights" element={<ProtectedRoute><AdminHighlightRegeneration /></ProtectedRoute>} />
        <Route path="/admin/prompts" element={<ProtectedRoute><AdminPrompts /></ProtectedRoute>} />
        <Route path="/admin/protected-poems" element={<ProtectedRoute><AdminProtectedPoems /></ProtectedRoute>} />
        <Route path="/admin/manage-data" element={<ProtectedRoute><ManageData /></ProtectedRoute>} />
        <Route path="/admin/tooltip-demo" element={<ProtectedRoute><TooltipDemo /></ProtectedRoute>} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  </BrowserRouter>
);

export default App;
